module.exports = __webpack_public_path__ + "static/2009-ribbon-fab0d7f19aae2d0a07d3b21f36a6434e.jpg";